import { RemoteGetAllGroupsUser } from 'data/usecases';
import { GetAllGroupsUserUseCaseInterface } from 'domain/usecases';
import { makeApiUrlGroupsUser } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllGroupsUser = (): GetAllGroupsUserUseCaseInterface =>
  new RemoteGetAllGroupsUser(makeApiUrlGroupsUser(), makeAxiosHttpClient());
